/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useState } from 'react';
import { useNode, useEditor, UserComponent } from '@craftjs/core';
import { FormControl } from '@mui/material';
import { Input } from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/Input';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';

import styles from './UIEditorBlocks.module.scss';
import { useTranslation } from 'react-i18next';
import { InputValuesContext } from '../../UIEditorTypes';
import { useContextSelector } from 'use-context-selector';

export interface TitleProps {
  text: string;
}

export const Title: UserComponent<TitleProps> = React.memo(function Title(
  props: TitleProps,
) {
  const { connectors, selected, actions } = useNode((state) => ({
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const { connect, drag } = connectors!;
  const { setProp } = actions;

  const { text } = {
    ...TitleDefaultProps,
    ...props,
  };

  const [value, setValue] = useState<string>(text);

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  const dataBlockTypeName = useContextSelector(
    InputValuesContext,
    (v) => v.dataBlockTypeName,
  );

  const i18next = useScopedTranslation('editor.blocks');
  const i18n = useTranslation();

  useEffect(() => {
    setProp((props: TitleProps) => (props.text = value));
  }, [value]);

  const editableTitle = (
    <Input
      placeholder={i18next.t('title_placeholder')}
      value={value}
      onChange={(e) => setValue(e.target?.value)}
    />
  );

  const notEditableTitle = (
    <div className={styles.titleElement}>
      {i18n.t(
        'data-block-fields:' +
          dataBlockTypeName +
          '.title_block.' +
          value.toLowerCase(),
        value,
      )}
    </div>
  );

  return (
    <div className={styles.titleContainer} ref={(ref) => connect(drag(ref!))}>
      <div className={styles.titleElementContainer}>
        {enabled ? editableTitle : notEditableTitle}
      </div>
    </div>
  );
});

const TitleSettings = () => {
  return (
    <div className={styles.settings}>
      <FormControl size="small" component="fieldset"></FormControl>
    </div>
  );
};

export const TitleDefaultProps = {
  text: 'Title',
};

Title.craft = {
  defaultProps: TitleDefaultProps,
  related: {
    settings: TitleSettings,
  },
};
